import { BblData } from "./collections/_deprecated/BblData";
import { Account } from "./collections/Account";
import { Admin } from "./collections/Admin";
import { Auth } from "./collections/Auth";
import { AutoCompliance } from "./collections/AutoCompliance";
import { Compliance } from "./collections/Compliance";
import { Bayou } from "./collections/Bayou";
import { Company } from "./collections/Company";
import { Customer } from "./collections/Customer";
import { Dashboard } from "./collections/Dashboard";
import { DataMiner } from "./collections/DataMiner";
import { Derapi } from "./collections/Derapi";
import { Document } from "./collections/Document";
import { Favorability } from "./collections/Favorability";
import { Incentive } from "./collections/Incentive";
import { IncentiveAdmin } from "./collections/IncentiveAdmin";
import { EspmPropertyType } from "./collections/EspmPropertyType";
import { ListUtility } from "./collections/ListUtility";
import { Location } from "./collections/Location";
import { Meter } from "./collections/Meter";
import { Onboarding } from "./collections/Onboarding";
import { Proposals } from "./collections/Proposals";
import { Projects } from "./collections/Projects";
import { Property } from "./collections/Property";
import { Screening } from "./collections/Screening";
import { ScreeningAdmin } from "./collections/ScreeningAdmin";
import { SolarPanel } from "./collections/SolarPanel";
import { Settings } from "./collections/Settings";
import { Survey } from "./collections/Survey";
import { Swtch } from "./collections/Swtch";
import { Uapi } from "./collections/Uapi";
import { Utility } from "./collections/Utility";
import { Territory } from "./collections/Territory";
import { IZeosApiConfig } from "./IZeosApiConfig";
import { IZeosApiService } from "./IZeosApiService";
import { init } from "./ZeosApiExecutor";

export const ZeosApiService: IZeosApiService = {
  Account,
  Admin,
  Auth,
  AutoCompliance,
  Compliance,
  BblData,
  Bayou,
  Company,
  Customer,
  Dashboard,
  DataMiner,
  Derapi,
  Document,
  Favorability,
  IncentiveAdmin,
  Incentive,
  EspmPropertyType,
  ListUtility,
  Location,
  Meter,
  Onboarding,
  Proposals,
  Projects,
  Property,
  Screening,
  ScreeningAdmin,
  SolarPanel,
  Settings,
  Swtch,
  Survey,
  Uapi,
  Utility,
  Territory,

  init: async (config: IZeosApiConfig) => {
    await init(config);
  },
};
